import http from '../api/http'

export default {
  all: () => { return http.get('/product-lists/all') },
  getProducts: (listId) => { return http.get('/product-lists/products', { params: { listId } }) }
}



// WEBPACK FOOTER //
// ./src/services/product-lists.js